<template>
  <div :class="$style.root">
    <BaseCarouselComponent
      :auto-width="true"
      :center="true"
      :drag="false"
      :start="initialSlideIndex"
      ref="carousel"
      @setSlideIndex="slideIndex = $event"
    >
      <template #top="{ slideCount, slideIndex, goToSlide }">
        <client-only>
          <div :class="$style.carouselNav" >
            <BaseCarouselGoComponent
              :class="$style.carouselButton"
              :go-to-slide="goToSlide"
              index="<"
              :disabled="slideIndex === 1 || itemsByMonth?.length === 1"
            >
              <coreButtonsArrowComponent />
            </BaseCarouselGoComponent>

            <BaseCarouselGoComponent
              :class="$style.carouselButton"
              :go-to-slide="goToSlide"
              index=">"
              :disabled="slideIndex === slideCount || itemsByMonth?.length === 1"
            >
              <coreButtonsArrowComponent dir='next' />
            </BaseCarouselGoComponent>
          </div>
        </client-only>
      </template>

      <BaseCarouselSlideComponent
        v-for="(group, index) in itemsByMonth"
        :key="`${index}-${year}`"
        @click="goToSlide($event, index)"
        :class="$style.slide"
      >
        <PagesEventsQueryListGroupComponent :group="group" />
      </BaseCarouselSlideComponent>
    </BaseCarouselComponent>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  eventsData: {
    type: Array,
    required: true
  },
  year: {
    type: Number,
    required: true
  }
})

const itemsByMonth = computed(() => {
  return eventsGetItemsForMonth(eventsGetStartOfMonths(props?.eventsData, props?.year), props?.eventsData)
})

const queryMonth = computed(() => route?.query?.month)

const slideIndexForMonth = computed(() => {
  const months = eventsGetStartOfMonths(props?.eventsData, props?.year)?.map(i => dayJs(i).format('M'))
  const index = months?.indexOf(queryMonth.value)
  return index >= 0 ? index : 0
})

const initialSlideIndex = computed(() => {
  const isCurrentYear = props.year === dayJs().year()
  if(isCurrentYear && !queryMonth.value) {
    const index = itemsByMonth.value?.findIndex((month: object) => {
      const currentMonth = dayJs().format('MMMM')
      return dayJs(month?.startOfMonth).format('MMMM') === currentMonth
    })
    return index
  } else if (queryMonth.value) {
    return slideIndexForMonth.value
  }  else {
    return 0
  }
})

watch(queryMonth, () => {
  if (queryMonth.value) {
    goToSlide(null, slideIndexForMonth.value)
  }
})

const carousel = ref(null)
const slideIndex = ref(0)
const goToSlide = (event: any, index: number) => {
  if (!carousel?.value?.goToSlide instanceof Function) return
  if ( index === slideIndex.value ) return
  carousel?.value?.goToSlide(index)
}
</script>

<style module lang="scss">
.root {
}

.carouselNav {
  composes: container from global;
  margin-bottom: var(--unit--default);
  display: flex;
  gap: var(--stroke--medium);
  justify-content: space-between;
}

.carouselButton {
  composes: reset-button button-disabled-state from global;
}

.slide:not(:global(.is-active)) * {
  pointer-events: none;
}
</style>
